"use strict";

exports.__esModule = true;
var _DeviceConnectivitySubscription = require("./DeviceConnectivitySubscription");
Object.keys(_DeviceConnectivitySubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceConnectivitySubscription[key]) return;
  exports[key] = _DeviceConnectivitySubscription[key];
});